<template>
  <div class="flex items-end w-full h-full uppercase">
    <span class="shrink-0 w-[85px] 2xl:w-32">#</span>
    <span>Customer</span>
  </div>
</template>
